import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import { PropertyCardCarouselComponent } from '../../../shared/components/carousels/property-card-carousel/property-card-carousel.component';
import { SectionTitleComponent } from '../../../shared/components/ui-elements/section-title/section-title.component';
import { TabComponent } from '../../../shared/components/tab/tab.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { DestinationsService } from '../../../reducers/services/destinations.service';

export interface Hotel {
  name: string;
  location: string;
  image: string;
  isNew?: boolean;
}

@Component({
  selector: 'app-home-our-properties',
  standalone: true,
  imports: [
    PropertyCardCarouselComponent,
    SectionTitleComponent,
    TabComponent,
    CommonModule,
  ],
  templateUrl: './home-our-properties.component.html',
  styleUrl: './home-our-properties.component.scss',
})
export class HomeOurPropertiesComponent {
  @Input() title: string = '';
  destinations: any = [{ name: 'All', slug: '' }];
  selectedIndex = 0;

  hotels!: any[];
  isBrowser: boolean = false;
  selectedDestSlug: string = this.destinations[0]?.slug || '';
  constructor(
    private destinationsService: DestinationsService,
    private cdr: ChangeDetectorRef
  ) {
    const platformId = inject(PLATFORM_ID);
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.loadDestinations();
    this.fetchHotels();
  }

  loadDestinations(): void {
    this.destinationsService.getDestinationDropDown().subscribe((response: any) => {
      if (response?.data?.length) {
        this.destinations = [
          {
            ...this.destinations[0],
            badgeCount: response.totalHotelCount ?? 0
          },
          ...response.data.map((item: any) => ({
            ...item,
            badgeCount: item.hotelCount ?? 0
          }))
        ];
        this.cdr.detectChanges();
      }
    });
  }

  onTabChange(index: number): void {
    this.selectedIndex = index;
    const selectedDestSlug = this.destinations[index]?.slug;
    this.selectedDestSlug = selectedDestSlug;
    this.fetchHotels();
  }

  fetchHotels(): void {
    this.destinationsService
      .getHotels(this.selectedDestSlug, '', 1, 1000)
      .pipe()
      .subscribe({
        next: (response: any) => {
          this.hotels = response?.data;
        },
        error: (err: any) => {
          console.error('Failed to fetch hotels:', err);
        },
      });
  }
}
